import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LogoState } from '@plys/src/application/states/logo.state';
import { ResizePipe } from '@plys/src/ui/media/resize.pipe';

@Component({
  selector: 'plys-shop-logo',
  templateUrl: './shop-logo.component.html',
  styleUrls: ['./shop-logo.component.scss'],
  standalone: true,
  imports: [CommonModule, ResizePipe],
})
export class ShopLogoComponent {
  logo$ = this.logoState.logo$;
  shopWebsite$ = this.logoState.shopWebsite$;

  constructor(private logoState: LogoState) {}
}
